export default __webpack_public_path__ + "static/media/playstore_1.f4b1c4a2.svg";